import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";
import { Typography } from "@mui/material";

const AddViewComments = () => {
  return (
    <div>
      <PageTitle title='Add/View Comments' role='Reviewer' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='After logging in as a role with Reviewer privileges, any events waiting on the Reviewer to review will allow the Reviewer to also submit additional comments. These events assigned to the Reviewer will be listed under the "My Reviews" tab. If no tab is present, then no reviews are currently assigned. Once clicking on the "My Reviews" tab, a table listing all the assigned events will be populated. Click on the event to review to view the Event Summary page. Note: Approvers may also comment if he or she is assigned to the event. Risk Managers and above can submit comments at any time.' />
      <ParaImageDialog src='/tutorial_image/add-view-comments-1.png' />
  
      <ParaTitle paraTitle='Comments Tab' />
      <Paragraph paragraph='The comments are listed under the "Comments" tab on the Event Summary page. The comments table shows the time the comment was sent, who sent the comment and who the comment is sent to, and the comment message. There are three different comment types:' />
      <ol>
        <Typography variant="body1" component="li">A personal note where the sender and receiver are the same user. No other users can read this note.</Typography>
        <Typography variant="body1" component="li">A personal message between two users, a sender and a receiver. The only users who can read this message are the two people involved.</Typography>
        <Typography variant="body1" component="li">A public comment that is broadcasted out to all users involved in the event. All users with access to the Event Summary can view this comment.</Typography>
      </ol>
      <ParaImageDialog src='/tutorial_image/add-view-comments-2.png' />

      <ParaTitle paraTitle='Adding Comments' />
      <Paragraph paragraph='When adding a comment, it is required to type in the content into the "Add New Comment" textarea and select who to send the comment to. If the comment is a personal note to send to nobody other than the current logged in user, then select "Personal Note". If the comment is a personal comment intended to be sent to one other person, select the person&#39;s name from the drop down list. If the comment is a general and public comment intended to be sent to everyone, then select "All" from the drop down list.' />
      <ParaImageDialog src='/tutorial_image/add-view-comments-3.png' />

      <ParaTitle paraTitle='No Comments' />
      <Paragraph paragraph='If no comments have been submitted for the event, the table displays a message saying "No comments for this event".' />
      <ParaImageDialog src='/tutorial_image/add-view-comments-4.png' />

      <Pagination
        pagination={{
          prev: { name: 'Assign Reviewers', link: '/risk-manager/assign-reviewers' },
          next: { name: 'Linked Events', link: '/risk-manager/linked-events' }
        }}
      />
    </div>
  );
};

export default AddViewComments;
